export function normalizePlanCurrency(currency) {
  const raw = String(currency || 'TND').trim().toUpperCase();
  if (raw === '€' || raw === 'EURO' || raw === 'EUROS') return 'EUR';
  if (raw === '$' || raw === 'DOLLAR' || raw === 'DOLLARS') return 'USD';
  if (['TND', 'EUR', 'USD'].includes(raw)) return raw;
  return 'TND';
}

const LOCALE_BY_CODE = {
  TND: 'fr-TN',
  EUR: 'fr-FR',
  USD: 'en-US',
};

export function formatPlanPrice(price, currency = 'TND') {
  const num = Number(price);
  if (!num && num !== 0) return 'Gratuit';
  if (num === 0) return 'Gratuit';

  const code = normalizePlanCurrency(currency);
  try {
    return new Intl.NumberFormat(LOCALE_BY_CODE[code] || 'fr-TN', {
      style: 'currency',
      currency: code,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(num);
  } catch {
    return `${num.toFixed(2)} ${code}`;
  }
}

export function formatPlanPricePerMonth(price, currency, billingCycle) {
  const main = formatPlanPrice(price, currency);
  if (main === 'Gratuit') return main;
  const cycle = billingCycle === 'yearly' ? 'an' : 'mois';
  return `${main}/${cycle}`;
}
